<script lang="ts">
  import { Col, Container ,Row} from "sveltestrap";
  import BookmarkFlagicon from "./BookmarkFlagicon.svelte";
  import Card from "../../Core/Card.svelte";
  import { FlagIcons } from "../../../utils/Constant/Constant";
  import FlagIconsData from "../../../Data/IconsData/FlagIcons.json"
  import {iTag,icons,iconClick} from "../../../store";
  import IconBottom from "../IconBottom.svelte";
  function getItag(tag:any) {
    iTag.update(value => value = '<i class="flag-icon flag-icon-' + tag + '"></i>');
    icons.update(value=> value = 'flag-icon flag-icon-' + tag ) ;
    iconClick.update(value => value = true);
  }
</script>
<BookmarkFlagicon />
<Container fluid>
    <Row>
      <Col sm="12">
        <Card headerTitle={FlagIcons} cardHeaderprops="pb-0">
          <div slot="contentbody" >
            <Row class="icon-lists flag-icons">
                {#each FlagIconsData as icon}
                    <Col sm="6" xs="12" xl="4" >
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <div class="media" on:click={() => getItag(icon.abbrivation)}> 
                            <i class={`flag-icon flag-icon-${icon.abbrivation}`} />
                            <div class="align-self-center media-body">
                                <h5>{icon.abbrivation}</h5>
                                <h6 class="mt-0">{icon.name}</h6> 
                            </div>
                        </div>
                    </Col>
                {/each}
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
</Container>
<IconBottom />
